import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { DateItem, HourItem } from '../showtime-streaming-in-cinemas/performance/performance.component';
import { faAngleLeft, faAngleRight } from '@fortawesome/free-solid-svg-icons';
import { SwiperOptions } from 'swiper/types';

@Component({
  selector: 'ush-dates-carousel',
  templateUrl: './dates-carousel.component.html',
  styleUrls: ['./dates-carousel.component.scss']
})
export class DatesCarouselComponent implements OnInit, OnChanges {
  @Input() dates?: DateItem[] = [];
  @Input() hours?: HourItem[] = [];
  @Output() itemSelected = new EventEmitter<any>();

  @ViewChild('swiper') swiper: any;

  prevArrowSelector: string;
  nextArrowSelector: string;
  prevIcon = faAngleLeft;
  nextIcon = faAngleRight;
  nextArrowDisabled = true;
  prevArrowDisabled = true;

  swiperConfig: SwiperOptions;

  ngOnInit(): void {
    this.setSwiperConfig();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.dates || changes.hours) {
      this.setSwiperConfig();
    }
  }

  onItemSelected(item: DateItem | HourItem): void {
    if (this.isDateItem(item)) {
      this.itemSelected.emit(item as DateItem);
    } else {
      this.itemSelected.emit(item as HourItem);
    }

    //TODO Tracking
  }

  private isDateItem(obj: DateItem | HourItem): obj is DateItem {
    return obj && typeof (obj as DateItem).dayLiteral !== 'undefined';
  }

  slidePrev() {
    const swiperInstance = this.getSwiperInstance();
    if (swiperInstance) {
      swiperInstance.slidePrev();
    }
  }

  slideNext() {
    const swiperInstance = this.getSwiperInstance();
    if (swiperInstance) {
      swiperInstance.slideNext();
    }
  }

  private getSwiperInstance() {
    return this.swiper.nativeElement.swiper;
  }

  private setSwiperConfig() {
    this.setArrowsCssSelectors();
    this.swiperConfig = {
      slidesPerView: 'auto',
      modules: [myPlugin(this)],
      spaceBetween: 15,
      breakpointsBase: 'container',
      scrollbar: true,
      navigation: {
        nextEl: '.' + this.nextArrowSelector,
        prevEl: '.' + this.prevArrowSelector
      },
      breakpoints: {
        400: {
          spaceBetween: 20
        },
        700: {
          spaceBetween: 30
        },
        1500: {
          spaceBetween: 30
        }
      },
      a11y: {
        enabled: true,
        prevSlideMessage: $localize`:@@prev-slide:Previous slide`,
        nextSlideMessage: $localize`:@@next-slide:Next slide`
      }
    };
  }

  private setArrowsCssSelectors() {
    const randomId = this.generateRandomId();
    this.prevArrowSelector = `prev-${randomId}`;
    this.nextArrowSelector = `next-${randomId}`;
  }

  private generateRandomId() {
    return Math.random().toString(36).substring(7);
  }
}

// Plugin that will manually determine if the arrows should be disabled or not (needed for swiper in encapsulation.ShadowDom for angular elements)
function myPlugin(componentInstance: DatesCarouselComponent) {
  return ({ swiper, extendParams, on }: any) => {
    extendParams({
      debugger: true
    });
    on('init', () => {
      if (!swiper.params.debugger) return;
      if (!swiper.isEnd) {
        componentInstance.nextArrowDisabled = false;
      }
    });
    on('slideChange', (swiper: any) => {
      if (!swiper.params.debugger) return;
      if (!swiper.isBeginning) {
        componentInstance.prevArrowDisabled = false;
      } else {
        componentInstance.prevArrowDisabled = true;
      }
      if (!swiper.isEnd) {
        componentInstance.nextArrowDisabled = false;
      } else {
        componentInstance.nextArrowDisabled = true;
      }
    });
    on('reachBeginning', () => {
      if (!swiper.params.debugger) return;
      componentInstance.prevArrowDisabled = true;
    });
    on('reachEnd', () => {
      if (!swiper.params.debugger) return;
      componentInstance.nextArrowDisabled = true;
    });
  };
}
